// redux/reducers/locations.reducer.js
import { LOCATIONS_FETCH } from "../constants";

const initialState = {
  locations: null,
};

export default function locationsReducer(state = initialState, action) {
  switch (action.type) {
    case LOCATIONS_FETCH:
      return { ...state, locations: action.result };

    default:
      return state;
  }
}
